import * as React from 'react';

const MicrophoneSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="microphone_svg__eds-icon--microphone_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="microphone_svg__eds-icon--microphone_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 12c0 2.6-2 4.7-4.5 5v-1c2-.2 3.5-1.9 3.5-4V6c0-2.2-1.8-4-4-4S8 3.8 8 6v6c0 2 1.5 3.7 3.5 4v1C9 16.7 7 14.6 7 12H6c0 3.1 2.4 5.7 5.5 6v3H10v1h4v-1h-1.5v-3c3.1-.3 5.5-2.8 5.5-6h-1zm-8 0h2v-1H9v-1h2V9H9V8h2V7H9V6c0-1.7 1.3-3 3-3s3 1.3 3 3v6c0 1.7-1.3 3-3 3s-3-1.3-3-3"
        />
    </svg>
);

MicrophoneSvg.displayName = 'MicrophoneSvg';
export default MicrophoneSvg;
